import type { ErrorInfo, ErrorMessageIf } from '@/utils/globalError/entities/valueObjects/types'
import { ERROR_CODES } from './errorCode'

const defaultErrorObject: ErrorInfo = {
  message: '',
  needsSupport: false,
  note: '',
  title: ''
} as const

/** エラーコード不明時のメッセージ内容 */
export const UNKNOWN_MESSAGE = {
  ...defaultErrorObject,
  message: '不明なエラーが発生しました。'
}

/** エラーメッセージ */
export const ERROR_MESSAGES: ErrorMessageIf = {
  /** 共通メッセージ */
  [ERROR_CODES._811000_ROUTE_ACCESS_ERROR]: {
    ...defaultErrorObject,
    message: '操作する権限がありません。'
  },
  [ERROR_CODES._811001_GOVERNMENT_SETTING_ERROR]: {
    ...defaultErrorObject,
    message: '操作する権限がありません。'
  },
  [ERROR_CODES._811010_API_EXECUTION_FAILED]: {
    ...defaultErrorObject,
    message: 'API の実行に失敗しました。(原因: アクセス回線障害など) '
  },
  // ログイン画面
  [ERROR_CODES._811100_QUERY_GOVERNMENT_SETTING_ERROR]: {
    ...defaultErrorObject,
    message: '自治体設定の取得に失敗しました。'
  },
  [ERROR_CODES._811101_QUERY_DISASTER_ERROR]: {
    ...defaultErrorObject,
    message: '災害情報の取得に失敗しました。'
  },
  // 団体管理者ユーザ管理画面エラー
  [ERROR_CODES._811201_FETCH_USER_ERROR]: {
    ...defaultErrorObject,
    message: 'ユーザーデータの取得に失敗しました。'
  },
  [ERROR_CODES._811202_CREATE_USER_ERROR]: {
    ...defaultErrorObject,
    message: 'ユーザーの登録に失敗しました。'
  },
  [ERROR_CODES._811203_UPDATE_USER_ERROR]: {
    ...defaultErrorObject,
    message: 'ユーザーの更新に失敗しました。'
  },
  [ERROR_CODES._811204_DELETE_USER_ERROR]: {
    ...defaultErrorObject,
    message: 'ユーザーの削除に失敗しました。'
  },

  // 団体メンバユーザ管理画面エラー
  [ERROR_CODES._811301_FETCH_USER_ERROR]: {
    ...defaultErrorObject,
    message: 'ユーザーデータの取得に失敗しました。'
  },
  [ERROR_CODES._811302_CREATE_USER_ERROR]: {
    ...defaultErrorObject,
    message: 'ユーザーの登録に失敗しました。'
  },
  [ERROR_CODES._811303_UPDATE_USER_ERROR]: {
    ...defaultErrorObject,
    message: 'ユーザーの更新に失敗しました。'
  },
  [ERROR_CODES._811304_DELETE_USER_ERROR]: {
    ...defaultErrorObject,
    message: 'ユーザーの削除に失敗しました。'
  },

  // ファイルアップロードAPI
  [ERROR_CODES._815001_S3_PUT_HTTP_STATUS_ERROR]: {
    ...defaultErrorObject,
    message: 'ファイルアップロードに失敗しました。'
  },
  [ERROR_CODES._815002_S3_PUT_NOT_FOUND_ETAG_ERROR]: {
    ...defaultErrorObject,
    message: 'ファイルアップロードに失敗しました。'
  },

  // プロジェクト一覧取得API
  [ERROR_CODES._815101_GET_PROJECT_LIST_ERROR]: {
    ...defaultErrorObject,
    message: 'プロジェクト情報の取得に失敗しました。'
  }
} as const
